import React from 'react';

interface AlarmIconProps extends React.SVGProps<SVGSVGElement> {
    // Add any specific props you might need, e.g., size, color overrides
}

const AlarmIcon: React.FC<AlarmIconProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 479.988 479.988"
            width="32px"
            height="32px"
            {...props} // Spread remaining props for flexibility (e.g., className, width, height)
        >
            <g>
                <path style={{ fill: '#F47F31' }} d="M239.994,0h-4.854c-2.959,0-5.358,2.399-5.358,5.358v60.771c0,2.959,2.399,5.358,5.358,5.358h4.854 h4.854c2.959,0,5.358-2.399,5.358-5.358V5.358c0-2.959-2.399-5.358-5.358-5.358H239.994z" />
                <path style={{ fill: '#F47F31' }} d="M64.779,73.603l-3.432,3.432c-2.093,2.093-2.093,5.485,0,7.578l42.971,42.972 c2.093,2.092,5.485,2.092,7.578,0l3.433-3.433l3.433-3.433c2.092-2.093,2.092-5.485,0-7.578L75.79,70.17 c-2.093-2.092-5.485-2.092-7.578,0L64.779,73.603z" />
                <path style={{ fill: '#F47F31' }} d="M4.514,255.347l0.394,4.838c0.239,2.95,2.825,5.146,5.774,4.907l60.571-4.924 c2.95-0.239,5.146-2.824,4.907-5.773l-0.394-4.839l-0.394-4.839c-0.239-2.949-2.824-5.146-5.774-4.906l-60.571,4.923 c-2.949,0.239-5.146,2.825-4.906,5.774L4.514,255.347z" />
            </g>
            <path style={{ fill: '#FFB450' }} d="M354.922,198.878c-1.456-22.82-20.39-40.584-43.257-40.584h-71.671h-71.671 c-22.867,0-41.801,17.764-43.257,40.584l-12.249,186.983c-0.26,3.963,2.885,7.32,6.856,7.32h120.321h120.32 c3.972,0,7.116-3.357,6.856-7.32L354.922,198.878z" />
            <path style={{ fill: '#F47F31' }} d="M239.994,260.42c-11.28,0-20.425,9.144-20.425,20.424v112.338h20.425h20.425V280.844 C260.419,269.563,251.274,260.42,239.994,260.42z" />
            <path style={{ fill: '#75D2FC' }} d="M392.252,473.478l-6.446-45.126c-1.628-11.392-11.384-19.853-22.89-19.853H239.994H117.072 c-11.506,0-21.262,8.461-22.89,19.853l-6.446,45.126c-0.49,3.436,2.175,6.51,5.646,6.51h146.612h146.611 C390.076,479.988,392.742,476.914,392.252,473.478z" />
            <g>
                <path style={{ fill: '#F47F31' }} d="M415.209,73.603l3.433,3.432c2.092,2.093,2.092,5.485,0,7.578l-42.972,42.972 c-2.093,2.092-5.485,2.092-7.578,0l-3.433-3.433l-3.433-3.433c-2.092-2.093-2.092-5.485,0-7.578l42.972-42.972 c2.093-2.092,5.485-2.092,7.578,0L415.209,73.603z" />
                <path style={{ fill: '#F47F31' }} d="M475.474,255.347l-0.394,4.838c-0.239,2.95-2.825,5.146-5.774,4.907l-60.572-4.924 c-2.949-0.239-5.146-2.824-4.906-5.773l0.394-4.839l0.394-4.839c0.239-2.949,2.824-5.146,5.774-4.906l60.571,4.923 c2.949,0.239,5.146,2.825,4.906,5.774L475.474,255.347z" />
            </g>
            {/* The empty <g> tags below were present in the original SVG. 
                They don't render anything but are kept for fidelity. 
                Remove them if they are unnecessary. */}
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
        </svg>
    );
};

export default AlarmIcon;
